import React from "react";
import { Phone, Mail, MessageSquare } from "lucide-react";

// Renders Call / Text / Email buttons for a recruit. Each button appears only when
// the matching contact detail is present. `email` falls back to the account email.
export default function ContactActions({ phone, email, name = "recruit", size = "sm" }) {
  const tel = (phone || "").trim();
  const mail = (email || "").trim();
  if (!tel && !mail) return null;

  const base = size === "sm" ? "text-sm px-3 py-1.5" : "text-sm px-3 py-2";
  const cls = `${base} rounded border border-[var(--rsp-border)] text-[var(--rsp-gray)] hover:text-[var(--rsp-cream)] hover:border-[var(--rsp-gold)] flex items-center gap-1 transition-colors`;

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="contact-actions">
      {tel && (
        <a href={`tel:${tel}`} className={cls} data-testid="contact-call" title={`Call ${name}`}>
          <Phone size={14} /> Call
        </a>
      )}
      {tel && (
        <a href={`sms:${tel}`} className={cls} data-testid="contact-sms" title={`Text ${name}`}>
          <MessageSquare size={14} /> Text
        </a>
      )}
      {mail && (
        <a href={`mailto:${mail}`} className={cls} data-testid="contact-email" title={`Email ${name}`}>
          <Mail size={14} /> Email
        </a>
      )}
    </div>
  );
}
